/**
 * Normalize `current_role.policy` from `/api/verify` for `hasPolicy` checks.
 * Mirrors Angular's expectation of `string[]` with `.includes()`; some responses use
 * objects or wrapped shapes.
 */
export function normalizeRolePolicies(raw: unknown): string[] {
  if (raw == null) return []

  if (typeof raw === 'string') {
    const t = raw.trim()
    if (!t) return []
    if (t.startsWith('[')) {
      try {
        return normalizeRolePolicies(JSON.parse(t) as unknown)
      } catch {
        return [t]
      }
    }
    if (t.includes(',')) {
      return t
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    }
    return [t]
  }

  if (!Array.isArray(raw)) return []

  const out: string[] = []
  for (const item of raw) {
    if (typeof item === 'string') {
      const s = item.trim()
      if (s) out.push(s)
    } else if (item && typeof item === 'object' && !Array.isArray(item)) {
      const o = item as Record<string, unknown>
      const key = o.policy_name ?? o.policy_key ?? o.name ?? o.key ?? o.policy
      if (typeof key === 'string' && key.trim()) out.push(key.trim())
    }
  }
  return out
}
